<div class="ui attached segment" appMargin marginT="5">
  <div fxLayout="row" fxLayoutGap="15px" fxLayoutAlign="start stretch">
    <div fxFlex="10" class="wrapped">
      {{ jsonConverter(log?.metaData)?.ipAddress }}
    </div>

    <div fxFlex="15" class="wrapped">
      {{ jsonConverter(log?.metaData)?.username }}
    </div>

    <div fxFlex="10" class="wrapped">
      {{ jsonConverter(log?.metaData)?.action }}
    </div>

    <div fxFlex="10" class="wrapped">
      {{ log?.dateCreated | amTimeAgo }}
    </div>

    <div fxFlex="25" class="wrapped">
      {{ jsonConverter(log?.metaData)?.fileName || "---" }}
    </div>

    <div fxFlex="10" class="wrapped">
      {{ jsonConverter(log?.metaData)?.fileExtension || "--" }}
    </div>

    <div fxFlex="10" class="wrapped">
      {{ jsonConverter(log?.metaData)?.fileSize }}
    </div>

    <div fxFlex="10" class="wrapped">
      <div
        class="ui small circular medium label"
        [ngClass]="{
          green: log?.logStatus === 'SUCCESS' || log?.logStatus === 'PAID',
          red: log?.logStatus === 'REJECTED' || log?.logStatus === 'FAILURE',
          teal: log?.logStatus === 'ON_GOING' || log?.logStatus === 'PENDING'
        }"
      >
        {{ log?.logStatus }}
      </div>
    </div>
  </div>
</div>
